import React from "react";
import { getCenters, getMyManagerName } from "../../api"; // <-- use getMyManagerName

export default function SidebarUserBadge() {
  const [account] = React.useState(() => {
    try { return JSON.parse(localStorage.getItem("kskfield_user")); } catch { return null; }
  });

  const [modalOpen, setModalOpen] = React.useState(false);
  const [centerMap, setCenterMap] = React.useState({});
  const [managerName, setManagerName] = React.useState("");

  const centersArr = Array.isArray(account?.centers) ? account.centers : [];

  // Resolve centers if only IDs stored
  React.useEffect(() => {
    (async () => {
      if (!centersArr.length) return;
      const first = centersArr[0];
      if (typeof first === "object" && "name" in first) return; // already denormalized
      try {
        const res = await getCenters();
        const map = {};
        (res?.data || []).forEach((c) => { map[String(c._id)] = c; });
        setCenterMap(map);
      } catch (e) {
        console.error("[SidebarUserBadge] getCenters failed", e);
      }
    })();
  }, [centersArr]);

  // 🔹 Resolve manager username (supervisor)
  React.useEffect(() => {
    if (!account?.managerId) return;
    (async () => {
      try {
        const res = await getMyManagerName();
        setManagerName(res?.data?.username || "");
      } catch (e) {
        console.error("[SidebarUserBadge] getMyManagerName failed", e);
        setManagerName("");
      }
    })();
  }, [account?.managerId]);

  const districts = React.useMemo(() => {
    if (!centersArr.length) return [];
    const first = centersArr[0];
    if (typeof first === "object" && "name" in first) {
      return centersArr.map((c) => ({ id: c.id || c._id, name: c.name, code: c.code }));
    }
    return centersArr.map((id) => {
      const c = centerMap[String(id)];
      return { id, name: c?.name || String(id), code: c?.code };
    });
  }, [centersArr, centerMap]);

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}
        onClick={() => setModalOpen(true)}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="8" r="4" fill="#e5e7eb" />
          <path d="M4 20c0-3.3137 3.134-6 8-6s8 2.6863 8 6" fill="#e5e7eb" />
          <circle cx="12" cy="8" r="3" fill="#0f172a" opacity="0.15" />
        </svg>
        <span style={{ fontWeight: 600, color: "#0f172a" }}>
          {account?.username || "User"}
        </span>
      </div>

      {modalOpen && (
        <div
          className="ux-modal"
          onClick={() => setModalOpen(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.35)", display: "grid", placeItems: "center", padding: 12, zIndex: 9999 }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 16, maxWidth: 480, width: "100%", boxShadow: "0 10px 30px rgba(0,0,0,.15)" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontWeight: 700, fontSize: 18 }}>User Details</div>
              <button onClick={() => setModalOpen(false)} style={{ border: "none", background: "transparent", fontSize: 22, cursor: "pointer" }} aria-label="Close">×</button>
            </div>

            <div style={{ marginTop: 12, display: "grid", gap: 8 }}>
              <div><b>Username:</b> {account?.username || "—"}</div>
              <div><b>Role:</b> {account?.role || "—"}</div>

              {account?.managerId && (
                <div><b>Manager:</b> {managerName || "—"}</div>
              )}

              <div>
                <b>Centers/Districts:</b>
                {districts.length === 0 ? (
                  <span style={{ color: "#94a3b8", marginLeft: 6 }}>No centers</span>
                ) : (
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 6 }}>
                    {districts.map((d) => (
                      <span key={d.id} style={{ display: "inline-block", border: "1px solid #e5e7eb", background: "#f1f5f9", borderRadius: 999, padding: "4px 8px", fontWeight: 600, fontSize: 12, color: "#0f172a" }}>
                        {d.name}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
